import {
    dangerColor,
    greenColor
} from "../material-kit-pro-react.jsx";
import modalStyle from "../material-kit-pro-react/modalStyle.jsx";
  
const processingModalStyle = theme => ({
    ...modalStyle(theme),
    textCenter: {
        textAlign: "center"
    },
    justifyContentCenter: {
        WebkitBoxPack: "center !important",
        MsFlexPack: "center !important",
        justifyContent: "center !important",
        alignSelf: "center !important",
        marginTop: "0px"
    },
    modal: {
        ...modalStyle(theme).modal,
        maxWidth: "700px !important",
        padding: "25px 28px 30px",
    },
    modalHeader: {
        padding: "0px",
        position: "relative",
        paddingRight: "30px",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        "& .activate-btn": {
            marginTop: "-3px",
            background: greenColor
        }
    },
    modalTitle: {
        ...modalStyle(theme).modalTitle,
        textAlign: "left",
        fontWeight: "600",
    },
    modalBody: {
        ...modalStyle(theme).modalBody,
        paddingLeft: "0px",
        paddingRight: "0px",
        paddingTop: "25px",
        paddingBottom: "20px",
        "& .sd_loader": {
            width: "300px !important",
            height: "300px !important",
            [theme.breakpoints.down("xs")]: {
                width: "180px !important",
                height: "180px !important",
            },
            "& > div": {
                width: "250px !important",
                height: "250px !important",
                [theme.breakpoints.down("xs")]: {
                    width: "150px !important",
                    height: "150px !important",
                },
            },
            "& svg": {
                "& circle": {
                    strokeWidth: "1px"
                }
            }
        },
        "& img": {
            width: "100%"
        },
        "&.pt-0": {
            paddingTop: "0px"
        },
        "& h4": {
            fontWeight: "bold",
        },
        "& .text-content": {
            whiteSpace: "pre-line",
            "& span": {
                fontWeight: "500"
            } 
        },
        "& .mb-0": {
            marginBottom: "0px",
        },
        "& .mt-20": {
            marginTop: "20px"
        },
        "& .list-items": {
            marginTop: "20px",
            marginBottom: '20px',
            paddingLeft: "20px",
            "& p": {
                marginBottom: "0px",
            }
        },
    },
    modalFooter: {
        ...modalStyle(theme).modalFooter,
        justifyContent: "end !important",
        MsFlexPack: "end !important",
        WebkitBoxPack: "end !important",
        padding: "0px",
    },
    modalCloseButtonCustom: {
        position: "absolute",
        top: "2px",
        right: "0px",
        margin: "0px",
        padding: "0px",
        "& svg": {
            marginRight: "0px"
        }
    },
    errorMessage: {
        color: dangerColor[0]
    }
});
  
export default processingModalStyle;
  